<template lang="html">

  <section class="users">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Users</h4>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="4"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls="table"
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1"  v-b-modal.modal-new @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <!--<b-button variant="primary mr-1"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary"><i class="mdi mdi-file-import"></i>Import</b-button>-->
              </span>
            </div>
            <b-table 
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key="username"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-3 p-1 m-auto" style="min-width: 30px;" size="sm" variant="primary" v-b-modal.modal-edit @click="curItem=data.item; mainUsername=data.item.username;">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-3 p-1 m-auto" style="min-width: 30px;" size="sm" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
            </b-table>

            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
               <b-container class="row container-fluid">
                <div class="col-lg-6">
                  <div class="row col-lg-12">
                    <div class="col-lg-4">Username*:</div><input type="text" class="col-lg-7" placeholder="Username" v-model="curItem.username" disabled/>
                  </div>
                  <hr>
                  <div class="row col-lg-12">
                    <div class="col-lg-4">Password*:</div><input type="text" class="col-lg-7" placeholder="Password" v-model="curItem.password"/>
                  </div>
                  <hr>
                  <div class="row col-lg-12">
                    <div class="col-lg-4">Confirm Password*:</div><input type="text" class="col-lg-7" placeholder="Password" v-model="curItem.confirmPassword"/>
                  </div>
                </div>
                <hr>
                <div class="col-lg-4">                   
                  <template v-for="ckBox in ['active', 'mktg', 'ccadmEnabled', 'priceConfEnabled', 'packConfEnabled', 'apiUser']">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" :id="ckBox" v-model="curItem[ckBox]">
                      <label class="custom-control-label" :for="ckBox">{{ckBox}}</label>
                      <hr>
                    </div>
                  </template>
                </div>               
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem )">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <!-- Modal New -->
            <b-modal id="modal-new" title="New User" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container class="row container-fluid">
                <div class="col-lg-6">
                  <div class="row col-lg-12">
                    <div class="col-lg-4">Username*:</div><input type="text" class="col-lg-7" placeholder="Username" v-model="newItem.username"/>
                  </div>
                  <hr>
                  <div class="row col-lg-12">
                    <div class="col-lg-4">Password*:</div><input type="text" class="col-lg-7" placeholder="Password" v-model="newItem.password"/>
                  </div>
                  <hr>
                  <div class="row col-lg-12">
                    <div class="col-lg-4">Confirm Password*:</div><input type="text" class="col-lg-7" placeholder="Password" v-model="newItem.confirmPassword"/>
                  </div>
                </div>
                <hr>
                <div class="col-lg-4">                   
                  <template v-for="ckBox in ['active', 'mktg', 'ccadmEnabled', 'priceConfEnabled', 'packConfEnabled', 'apiUser']">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" :id="ckBox" v-model="newItem[ckBox]">
                      <label class="custom-control-label" :for="ckBox">{{ckBox}}</label>
                      <hr>
                    </div>
                  </template>
                </div>               
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button v-if="!showCreateButton" disabled variant="primary">
                    Salva
                  </b-button>
                  <b-button v-else variant="primary" @click="createItem()">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'users',
  methods: {
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.username+'?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value){

          this.setSpinnerStatus(true);
          this.axios
          .delete('/ccb/auth/fe/user/' + item.username ,this.authHeader)
          .then(response => {
            this.setSpinnerStatus(false);
            this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
              this.refreshTable();
              this.curItem=null;
            })
          }) 
          .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          }) 
        }

      })
      
    },
    saveCurItem(curItem) {
      window.curr = curItem
      var intLabObj = curItem
    
    if(intLabObj.password!=intLabObj.confirmPassword){
        this.$bvModal.msgBoxOk('Le due password non combaciano', {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
    }else{
      this.setSpinnerStatus(true);
      this.axios
        .put('/ccb/auth/fe/user/' + this.mainUsername, intLabObj ,this.authHeader)
        .then(response => {
           if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              .then(value => {
              this.refreshTable();
              })
            }    
          })
          .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit');
        })
      }
    },    
    createItem() {
      var intLabObj = this.newItem     
      if(intLabObj.password!=intLabObj.confirmPassword){
        this.$bvModal.msgBoxOk('Le due password non combiaciano', {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }else{
        this.setSpinnerStatus(true);
        this.axios
            .post('/ccb/auth/fe/user', intLabObj, this.authHeader)
              .then(response => {
                if(response.status == 200) {
                this.$bvModal.msgBoxOk(response.data.message, {
                  okVariant: 'success',
                  hideHeaderClose: false,
                  centered: true
                })
                .then(value => {
                  this.refreshTable();
                })           
              }
              })
              .catch(error => {
                this.$bvModal.msgBoxOk(error.message, {
                  okVariant: 'danger',
                  hideHeaderClose: false,
                  centered: true
                })
              }).finally(e=>{
                this.setSpinnerStatus(false);
                this.$bvModal.hide('modal-new')
              })   
        }
    },
    search() {
           this.setLastSearch(this.search) 
           this.setSpinnerStatus(true);
          this.axios
          .get('/ccb/auth/fe/user/allPaged', { params: {page: this.currentPage-1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc},
              ...this.authHeader})
            .then(response => {
              this.items = response.data.content;
              this.totalRowsResult = response.data.totalElements;
              this.setSpinnerStatus(false);
            }
          )
    },
    btnNew() {
      
    },
    refreshTable() {
        this.search();
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus'
    ])
  },
  watch: {
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    },
    ['newItem.username'](newValue,oldValue){
      if(newValue.length > 4 && 
          this.newItem.password && this.newItem.password.length > 4 &&
          this.newItem.confirmPassword && this.newItem.confirmPassword.length > 4 &&
           this.newItem.password == this.newItem.confirmPassword           
           ) {
             this.showCreateButton = true
           } else {
             this.showCreateButton = false
           }
    },
    ['newItem.password'](newValue,oldValue){
        if(newValue.length > 4 && 
          this.newItem.username && this.newItem.username.length >= 4 &&
          this.newItem.confirmPassword && this.newItem.confirmPassword.length >= 4 &&
           this.newItem.password == this.newItem.confirmPassword           
           ) {
             this.showCreateButton = true
           } else {
             this.showCreateButton = false
           }
    },
    ['newItem.confirmPassword'](newValue,oldValue){
      if(newValue.length > 4 && 
          this.newItem.username && this.newItem.username.length >= 4 &&
          this.newItem.password &&  this.newItem.password.length >= 4 &&
           this.newItem.password == this.newItem.password           
           ) {
             this.showCreateButton = true
           } else {
             this.showCreateButton = false
           }


    }
  },
  data () {
    return {
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      curItem: null,
      sortBy:'username',
      sortDesc: false,
      showCreateButton:false,
      mainUsername: null,
      newItem : {id:null, username: null, password: null, confirmPassword: null, active: true, mktg: false, ccadmEnabled: false, priceConfEnabled: false, packConfEnabled:false, apiUser: false},
      items: [],
      fields: [
        {
          key: 'username',
          //label: 'Code',
          sortable: false
        },
        {
          key: 'active',
          //label: 'Label',
          sortable: false
        },
        {
          key: 'mktg',
          label: 'Marketing User',
          sortable: false
        },
        {
          key: 'ccadmEnabled',
          //label: 'Label',
          sortable: false
        },
        {
          key: 'priceConfEnabled',
          //label: 'Label',
          sortable: false
        },
        {
          key: 'packConfEnabled',
          //label: 'Label',
          sortable: false
        },
        {
          key: 'apiUser',
          //label: 'Label',
          sortable: false
        },
        {
          key: 'buttons',
          label: 'Edit',
          sortable: false          
        }
      ]
    }
  },
  computed: {
    ...mapState([
      'curLanguage',
      'curModel',
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'authHeader'
    ])
  },
  mounted() {
    this.setCurApp('ccadm');
    this.refreshTable();
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
